import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo5/juanalay.png";
import Imagen2 from "../../../images/modulo5/elmerreniec.png";
import Imagen3 from "../../../images/modulo5/walterpepe.png";
import Imagen4 from "../../../images/modulo5/estelaauto.png";
import Imagen5 from "../../../images/modulo5/titonovia.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 6.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "nacimiento" },
    ans2: { value: "", valid: "", correctValue: "votar" },
    ans3: { value: "", valid: "", correctValue: "préstamo" },
    ans4: { value: "", valid: "", correctValue: "cheque" },
    ans5: { value: "", valid: "", correctValue: "viaje" },
    ans6: { value: "", valid: "", correctValue: "casaremos" },
  });
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[5];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[6].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[6].path}`,
    titlePrev: `${modulo5.content[0].activities[4].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="my-5">
        <li>
          Además de identificarnos como peruanos y peruanas, el DNI sirve para
          muchas otras cosas.
        </li>
        <li>
          Usa las palabras del recuadro para completar lo que dicen las
          personas.
        </li>
      </ul>

      <div className="row my-3 align-items-center justify-content-center">
        <div className="col-lg-10 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div>nacimiento</div>
              <div>votar</div>
              <div>préstamo</div>
              <div>casaremos</div>
              <div>viaje</div>
              <div>cheque</div>
            </div>
          </Card>
        </div>
      </div>

      <div className="row my-3 align-items-start justify-content-center">
        <div className="col-lg-4 col-md-6 col-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
          <Card>
            <p>
              Voy a inscribir el{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              <br />
              de mi hijito Gabriel.
            </p>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
          <Card>
            <p>
              Perdí mi DNI. Voy a sacar un duplicado para poder{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />{" "}
              <br />
              en las próximas elecciones.
            </p>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <img src={Imagen5} alt="Familia" className="img-fluid pt-2" />
          <Card>
            <p>
              Mi novia y yo nos{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans6.valid
                }
                value={answers.ans6.value}
                onChange={(event) => handleAnswers(event, "ans6")}
              />{" "}
              pronto. Para eso necesitamos nuestro DNI.
            </p>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <img src={Imagen3} alt="Familia" className="img-fluid" />

          <Card>
            <p>
              - Buenos días, don Pepe. Voy a pedir un{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />{" "}
              al banco para comprar un camión.
              <br />- ¡Suerte con eso! Yo voy a cobrar este{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans4.valid
                }
                value={answers.ans4.value}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
            </p>
          </Card>
        </div>

        <div className="col-lg-4 col-md-6 col-12">
          <img src={Imagen4} alt="Familia" className="img-fluid pt-4" />
          <Card>
            <p>
              Al aeropuerto, por favor. Me voy de{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm d-inline-block w-200 " +
                  answers.ans5.valid
                }
                value={answers.ans5.value}
                onChange={(event) => handleAnswers(event, "ans5")}
              />{" "}
              de trabajo.
            </p>
          </Card>
        </div>

        <div className="col-lg-5 offset-lg-4 col-12 offset-0">
          <div className="d-flex w-100 justify-content-end my-4">
            <button
              className={`btn btn-${modulo5.color}`}
              onClick={validateAnswers}
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y las palabras del recuadro. Observen las
          imágenes y lean lo que dicen los personajes. Haga notar en qué
          contexto está cada personaje para ayudar a encontrar las palabras
          faltantes. Destaque que esas son algunas de las cosas para las que
          sirve el DNI.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
